const COOKIES_ENABLED = 'cookies_enabled';
const COOKIES_LAST_CONSENTED = 'cookies_last_consented';

export const LOCAL_STORAGE_KEYS = {
  COOKIES_ENABLED,
  COOKIES_LAST_CONSENTED,
};
